import Modal from '../..';
import Form from '../../../Form';
import useStore from '../../../Hooks/useStore';

export interface ModalTaxUpdateProps {}

const ModalTaxUpdate = ({}: ModalTaxUpdateProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
  } = getters;
  const {
    modal: { closeSingleModal },
  } = setters;
  const isOpen = getModal('single.updateTax');
  const onClose = () => {
    closeSingleModal('updateTax');
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Atualizar taxa"
      height={'auto'}
      width={'60vw'}
    >
      <Form.Export.Tax.Update />
    </Modal>
  );
};

export default ModalTaxUpdate;
